var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H8.20746M8.20746 15H8.29254M8.20746 15C8.22162 15.0001 8.23581 15.0002 8.25 15.0002C8.26419 15.0002 8.27838 15.0001 8.29254 15M8.20746 15C5.32755 14.9771 3 12.6351 3 9.74983V6.69214C3 6.30979 3.30979 6 3.69214 6H12.8075C13.1899 6 13.5 6.30979 13.5 6.69214V6.75M8.29254 15H13.5M8.29254 15C11.1725 14.9771 13.5 12.6351 13.5 9.74983M13.5 6.75H14.625C15.6605 6.75 16.5 7.58947 16.5 8.625C16.5 9.66053 15.6605 10.5 14.625 10.5H13.5V9.74983M13.5 6.75V9.74983M11.25 2.25L10.5 3.75M9 2.25L8.25 3.75M6.75 2.25L6 3.75",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakbtn);
export default __webpack_public_path__ + "static/media/breakbtn.e2bc65fa43604296db830e720f6d5b73.svg";
export { ForwardRef as ReactComponent };